// import "./App.css";

import { Suspense, useContext } from "react";
import { WindowContext } from "../App";
import Viewer from "./View/Viewer";

function isLargeWall(currentWindow) {
  const windowsFromLager = ["3wfb", "3wAsync", "3wfbAsync"];
  return windowsFromLager.includes(currentWindow);
}

function CanvasContainer() {
  const { currentWindow } = useContext(WindowContext);

  return (
    <div id="canvas-container" className="canvas-container">
      <Suspense fallback={null}>
        <Viewer
          currentWindow={currentWindow}
          largeWall={isLargeWall(currentWindow)}
        ></Viewer>
      </Suspense>
    </div>
  );
}

export default CanvasContainer;
